import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Modal } from "_components";

export class ConfirmButton extends React.Component {
  state = {
    showModal: false,
  }

  showModal = () => this.setState({showModal: true})
  hideModal = () => this.setState({showModal: false})

  render = () => <React.Fragment>
    <button className={`btn btn-${this.props.contextualClass || 'default'}`} disabled={this.props.disabled} onClick={() => this.props.confirm ? this.showModal() : this.props.onConfirm()}>
      {this.props.icon && <React.Fragment><FontAwesomeIcon icon={this.props.icon} />&ensp;</React.Fragment>}
      {this.props.button}
    </button>
    <Modal.Dialog show={this.state.showModal || this.props.showModal}>
      <Modal.Header title={this.props.title || 'Are you sure?'} handleClose={this.hideModal} />
      {this.props.body && <Modal.Body>{this.props.body}</Modal.Body>}
      <Modal.Footer>
        <button className={`btn btn-${this.props.contextualClass || 'default'}`} onClick={this.props.onConfirm}>
          {this.props.icon && <React.Fragment><FontAwesomeIcon icon={this.props.icon} />&ensp;</React.Fragment>}
          {this.props.ok || 'OK'}
        </button>
        <button className='btn btn-default' onClick={this.hideModal}>{this.props.cancel || 'Cancel'}</button>
      </Modal.Footer>
    </Modal.Dialog>
  </React.Fragment>
}
